module.exports = __webpack_public_path__ + "static/media/5.47cbd94d.jpg";